import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
import routes, { renderRoutes } from './routes';
import AuthService from './SDA/AuthService';
import Unauthorized from './views/custom-pages/Unauthorized';
import SessionTimeout from './views/custom-pages/SessionTimeout';
import ProtectedRoute from './ProtectedRoute';
import SDACallback from './SDA/SDACallback';
import CustomError from './views/custom-pages/CustomError';

import ApiInterceptorComponent from './service/api';
import SessionManager from './utils/SessionManager';
import { getSessionStorage, isSessionValueReady } from './utils/helpers';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const publicRoutes = ['/unauthorized', '/session-timeout', '/error', '/dashboard/index'];

  useEffect(() => {
    const checkAuth = async () => {
      if (publicRoutes.includes(location.pathname)) {
        setIsLoading(false);
        AuthService.clearSession();
        return;
      }
      sessionStorage.setItem('SI_RD_P', AuthService.encryt(location.pathname));
      const user = await AuthService.getUserToken();
      const urlParams = new URLSearchParams(window.location.search);
      const authCode = urlParams.get('code');
      if (authCode && !user) {
        try {
          await AuthService.handleCallback();
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Error during authentication callback', error);
          navigate('/session-timeout');
        }
      } else if (!user || !AuthService.isAuthenticated()) {
        await AuthService.signinRedirect(location.pathname);
      } else {
        setIsAuthenticated(true);
        AuthService.scheduleTokenRefresh();
        // OAuth callback runs setUserDetails; on refresh / deep link, session keys may be missing.
        const idToken = await AuthService.getUserToken();
        if (
          idToken &&
          (!isSessionValueReady(getSessionStorage('USER_ID')) ||
            !isSessionValueReady(getSessionStorage('EMAIL')))
        ) {
          try {
            await AuthService.setUserDetails(idToken);
          } catch (e) {
            console.error('Failed to hydrate session from GetLoggedUserDetails', e);
          }
        }
      }
      setIsLoading(false);
    };
    checkAuth();
  }, [navigate, location.pathname]);
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <SessionManager>
      <ApiInterceptorComponent />
      <Routes>
        {/* Public Routes */}
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/session-timeout" element={<SessionTimeout />} />
        <Route path="/dashboard/index" element={<SDACallback />} />
        <Route path="/error" element={<CustomError />} />

        {/* Protected Routes */}
        <Route path="/*" element={<ProtectedRoute>{renderRoutes(routes)}</ProtectedRoute>} />
      </Routes>
    </SessionManager>
  );
};

const AppWrapper = () => (
  <Router>
    <App />{' '}
  </Router>
);

export default AppWrapper;
